import { cn } from '@/lib/tailwind.utils'
import { accentBgMap, accentBorderMap, accentTextMap, UseCaseConfig } from '../types'
import HomeContent from '../../../../src/components/SectionContent'

interface UseCasePageHeaderProps {
  useCase: UseCaseConfig
  className?: string
}

const UseCasePageHeader = ({ useCase, className }: UseCasePageHeaderProps) => {
  const { title, tagline, accentColor, iconComponent: Icon } = useCase

  return (
    <div
      className={cn(
        `border-t-8 border-b ${accentBorderMap[accentColor]}`,
        'py-6 md:py-12',
        className,
      )}
    >
      <HomeContent>
        <div className="flex items-center gap-4">
          <div
            className={cn(
              'flex h-14 w-14 shrink-0 items-center justify-center rounded-full',
              accentBgMap[accentColor],
            )}
          >
            <Icon />
          </div>
          <div className="flex flex-col gap-0.5">
            <span className="text-xs font-semibold tracking-widest uppercase text-muted-foreground">
              Use cases
            </span>
            <h1 className={cn('text-2xl font-semibold', accentTextMap[accentColor])}>{title}</h1>
            <p className="text-sm text-muted-foreground">{tagline}</p>
          </div>
        </div>
      </HomeContent>
    </div>
  )
}

export default UseCasePageHeader
